/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import user from 'js/lib/user';

import { useTheme } from '@coursera/cds-core';

import Modal from 'bundles/phoenix/components/Modal';
import LevelSetsResultContent from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/LevelSetsResultModal/LevelSetsResultContent';
import LevelSetsResultDataProvider from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/LevelSetsResultModal/LevelSetsResultDataProvider';
import LevelSetsResultDataState from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/LevelSetsResultModal/LevelSetsResultDataState';

type PropsFromCaller = {
  skillName: string;
  skillId: string;
  onCloseUpdatedModal: () => void;
};

export type Props = PropsFromCaller;

const LevelSetsResultModal = ({ skillName, skillId, onCloseUpdatedModal }: Props) => {
  const userId = user.get().id;
  const theme = useTheme();

  // If the user is unauthenticated, then there will be nothing to show, the results depend on the user
  if (!userId) return null;

  return (
    <Modal
      css={css`
        .c-modal-x-out {
          z-index: 10010;

          a {
            color: #fff;
          }
        }

        .c-modal-content {
          width: 900px;
          top: 50% !important;
          max-height: 100vh;
          overflow: auto;

          ${theme.breakpoints.down('xs')} {
            top: 0 !important;
            width: 100vw;
            max-width: 100vw;
            height: 100vh;
            max-height: 100vh;
            padding: 0;
          }
        }
      `}
      type="layer"
      modalName="LevelSetsResultModal"
      handleClose={onCloseUpdatedModal}
      allowClose={true}
    >
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          background: theme.palette.white,
          borderRadius: 6,
        }}
      >
        <LevelSetsResultDataProvider skillId={skillId} userId={userId}>
          {({ data, loading, error }) => {
            if (loading) return <LevelSetsResultDataState dataState="loading" />;
            if (error || !data) return <LevelSetsResultDataState dataState="error" />;
            return (
              <LevelSetsResultContent
                userId={userId}
                skillId={skillId}
                skillName={skillName}
                skillScore={data.updatedSkillScore}
                levelsetResults={data}
                onCloseUpdatedModal={onCloseUpdatedModal}
              />
            );
          }}
        </LevelSetsResultDataProvider>
      </div>
    </Modal>
  );
};

export default LevelSetsResultModal;
